import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import NewsCard from "./NewsCard";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./News.sass";

function slugify(title) {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const mainPageCallback = (hash) => {
    window.location.href = `/${hash}`;
  };

  const scrollContactSection = () => {
    window.location.href = "/#kontakt-formularz";
  };

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch('/static/news/news.json');
        if (!response.ok) {
          throw new Error('Failed to fetch news');
        }
        const data = await response.json();
        setNews(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) return <div className="news-loading">Loading...</div>;
  if (error) return <div className="news-error">Error: {error}</div>;

  return (
    <div className="news">
      <Header />
      <div className="news-container">
        <h1 className="news-title">{t("newsTitle")}</h1>
        <div className="news-list">
          {news.map((item, index) => (
            <Link 
              key={index} 
              to={`/aktualnosci/${slugify(item.title)}`}
              className="news-link"
            >
              <NewsCard news={item} />
            </Link>
          ))}
        </div>
      </div>
      <Footer mainPageCallback={mainPageCallback} scrollContactSection={scrollContactSection} />
    </div>
  );
};

export default News;
